import { utils } from '../utils.js';
import { beads } from '../beads.js';

export const rawConfig = {
    name: 'RAW',
    displayName: 'Right Angle Weave',
    colDist: () => 2 * (utils.getConvertedbeadDisplayHeight() + 4),
    rowDist: () => utils.getConvertedbeadDisplayHeight() + 4,
    offset: () => -utils.getConvertedbeadDisplayHeight() - 4,
    offsetPattern: [0, 1],
    apply: () => {
        beads.arr.forEach(bead => bead.setAngle(bead.row % 2 === 0 ? 90 : 0));
    },
    commutes: false,
    canSelectCommute: false,
    canSelectDirection: false,
    canSelectStartingBead: false,
    canSelectPanelWidth: false,
    canExportSmallDiagrams: false,
    plastic: false,
    noCustomBeadSize: true,
    brickDrag: true,
    simpleExport: true,
    splitExportImage: true,
    getDimensions: (myRows, myColumns, diameter, beadLength) => {
        return {
            width: (myColumns * diameter / 10) * 1.7,
            height: (myRows * beadLength / 10) * 1.085
        };
    },
    disabledTools: ['Row Shift', 'Star'],
    arrangeGrid: true
};